import { PermissionT } from "../types";

export const displaySalesProFastTrack = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "display_sales_pro_fast_track");
  return !!p;
};

export default displaySalesProFastTrack;
